import QuestionsBlock from './QuestionsBlock';
import { QuestionsBlockProps, QuestionsBlockValueProps } from './types';

export type { QuestionsBlockProps, QuestionsBlockValueProps };
export default QuestionsBlock;
